import React from 'react'
import SideNav from './SideNav'

const OutdoorDesigns = () => {
  return (
    <div>
      <>
        {/* Page Header */}
        <div className="page-header-outdoor parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Outdoor Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="page-service-single">
          <div className="container">
            <div className="row">
              {/* Left Section */}
              <div className="col-lg-8">
                <div className="service-single-content">
                  {/* Feature Image */}
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/outdoor-designs-hyderabad.jpg" alt="Outdoor Designs" />
                    </figure>
                  </div>

                  {/* Intro Section */}
                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      At <b>MeHome</b>, we believe your outdoor space is an extension of your home —
                      a place to unwind, entertain, and reconnect with nature. Our <b>Outdoor Design Services</b>
                       transform ordinary spaces into extraordinary experiences, blending natural beauty with
                      architectural elegance.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Crafting <span> Timeless Outdoor Experiences</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Whether it’s a cozy balcony retreat, a landscaped garden, or a luxurious terrace lounge,
                      our team brings 15+ years of design and construction expertise to every project.
                      We combine creativity, functionality, and sustainability to create outdoor spaces
                      that inspire and impress.
                    </p>

                    <ul>
                      <li>Elegant landscaping with natural elements and lush greenery.</li>
                      <li>Modern balcony and terrace transformations for urban lifestyles.</li>
                      <li>Ambient lighting and decor that enhance evening aesthetics.</li>
                      <li>Custom-built furniture for outdoor relaxation and gatherings.</li>
                      <li>Eco-friendly materials and sustainable design practices.</li>
                    </ul>
                  </div>

                  {/* Why Choose Us */}
                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> Outdoor Design Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Landscape & Garden Design</h3>
                          <p>
                            From lush lawns and decorative pathways to modern planters and flowerbeds,
                            we design gardens that rejuvenate your surroundings with tranquility and color.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🏡</div>
                        <div className="why-choose-item-content">
                          <h3>Balcony & Terrace Transformations</h3>
                          <p>
                            We turn compact balconies and rooftops into vibrant, functional spaces perfect
                            for relaxation, yoga, or evening get-togethers under the open sky.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Outdoor Lighting & Ambience</h3>
                          <p>
                            Thoughtfully designed lighting enhances mood and highlights your outdoor aesthetics.
                            We create perfect illumination with energy-efficient fixtures and warm tones.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🪴</div>
                        <div className="why-choose-item-content">
                          <h3>Pergolas & Gazebos</h3>
                          <p>
                            Add architectural elegance to your outdoors with stylish pergolas, gazebos,
                            and canopies designed for beauty and comfort throughout the seasons.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Outdoor Furniture & Decor</h3>
                          <p>
                            We design durable, weather-resistant furniture and décor elements that perfectly
                            complement your outdoor theme, from rustic to contemporary.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Benefits Section */}
                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Outdoor Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>6+ Years of Experience</b> – Trusted by clients across residential and commercial spaces.</li>
                        <li><b>Custom-Tailored Designs</b> – Every project reflects your taste and lifestyle.</li>
                        <li><b>End-to-End Execution</b> – From concept to completion, handled seamlessly.</li>
                        <li><b>High-Quality Materials</b> – Durable, weatherproof, and elegant finishes.</li>
                        <li><b>Sustainable Practices</b> – Eco-conscious designs for long-term beauty.</li>
                        <li><b>On-Time Project Delivery</b> – Transparent communication and efficient workflow.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default OutdoorDesigns
